import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import Icon from '@material-ui/core/Icon'
const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140
  },
  button: {
    width: '100%'
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  }
})

export default withStyles(styles)(
  class RightFormComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      handleChange: PropTypes.func.isRequired,
      checkAccountAvailability: PropTypes.func.isRequired,
      handleCreateHiboutikAccount: PropTypes.func.isRequired,
      hiboutikAccountValidity: PropTypes.bool,
      hiboutikAccount: PropTypes.string,
      hiboutikPassword: PropTypes.string,
      hiboutikCGS: PropTypes.bool,
      hbAccountCreated: PropTypes.bool
    }
    static defaultProps = {
      hiboutikAccount: '',
      hiboutikPassword: '',
      hiboutikAccountValidity: false,
      hiboutikCGS: false
    }
    state = {
      errors: {},
      showPassword: false,
      loading: false
    }
    updateState(nextProps) {
      const { hiboutikAccount, hiboutikPassword, hbAccountCreated } = nextProps
      const newState = { ...this.state, errors: {} }
      if (hiboutikPassword === '') {
        newState.errors.hiboutikPassword = 'Ce champs est requis'
      } else if (hiboutikPassword.length < 6) {
        newState.errors.hiboutikPassword =
          'Le mot de passe doit contenir au moins 6 caractères'
      }
      if (hiboutikAccount === '') {
        newState.errors.hiboutikAccount = `Ce champs est requis`
      } else if (!/^[a-z0-9][a-z0-9]?[a-z0-9]*$/.test(`${hiboutikAccount}`)) {
        newState.errors.hiboutikAccount = `Invalide (Le nom ne doit contenir que des caractères alpha-numériques)`
      }
      if (hbAccountCreated) {
        newState.loading = false
      }
      this.setState(newState)
    }
    handleChangeDone = e => {
      if (!e.target.value || e.target.value === '') {
        this.props.handleChange('hiboutikAccountValidity', false)
        this.setState({
          errors: {
            ...this.state.errors,
            hiboutikAccount: 'Ce champs est requis'
          }
        })
        return
      }
      this.props.checkAccountAvailability(e.target.value).then(res => {
        if (res.data.isValid) {
          this.props.handleChange('hiboutikAccountValidity', true)
          this.setState({
            errors: {
              ...this.state.errors,
              hiboutikAccount: void 0
            }
          })
        } else {
          this.props.handleChange('hiboutikAccountValidity', false)
          this.setState({
            errors: {
              ...this.state.errors,
              hiboutikAccount: 'Ce compte existe déjà ! '
            }
          })
        }
      })
    }
    handleCreateAccountClick = e => {
      this.setState({ loading: true })
      this.props.handleCreateHiboutikAccount()
    }
    handleChange = name => event => {
      let value =
        name === 'hiboutikCGS' ? event.target.checked : event.target.value
      // let errorMessage = validate(name, value).errorMessage
      this.props.handleChange(name, value)
      if (name === 'hiboutikAccount') {
        this.props.handleChange('hiboutikAccountValidity', false)
      }
    }
    handleMouseDownPassword = event => {
      event.preventDefault()
    }

    handleClickShowPasssword = () => {
      this.setState({ showPassword: !this.state.showPassword })
    }
    componentDidMount() {
      if (
        !this.props.hiboutikAccountValidity &&
        this.props.hiboutikAccount !== ''
      ) {
        this.setState({
          ...this.state,
          errors: { hiboutikAccount: `Ce compte n'est pas valide` }
        })
      }
    }
    componentWillReceiveProps(nextProps) {
      if (
        nextProps.hiboutikAccount !== this.props.hiboutikAccount ||
        nextProps.hiboutikPassword !== this.props.hiboutikPassword
      ) {
        this.updateState(nextProps)
      }
    }
    render() {
      const {
        classes,
        hiboutikAccount,
        hiboutikPassword,
        hiboutikCGS,
        hiboutikAccountValidity
      } = this.props
      const { showPassword, loading } = this.state
      const { errors } = this.state
      let hiboutikAccountHelper = `Le nom ne doit contenir que des caractères alpha-numériques`
      if (hiboutikAccountValidity) {
        hiboutikAccountHelper = `Ce compte est valide`
      }
      const createAccountDisabled =
        this.props.hbAccountCreated ||
        !(hiboutikAccountValidity && hiboutikCGS && hiboutikPassword !== '')
      return (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          alignContent="space-between"
          spacing={24}>
          <Grid item xs={11} sm={10} md={10}>
            <Typography variant="title">Compte Hiboutik</Typography>
          </Grid>
          <Grid item xs={10} sm={9} md={9}>
            <Divider light />
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.hiboutikAccount}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="hbAccount-input">Compte Hiboutik</InputLabel>
              <Input
                id="hbAccount-input"
                value={hiboutikAccount}
                onBlur={this.handleChangeDone}
                onChange={this.handleChange('hiboutikAccount')}
                disabled={this.props.hbAccountCreated || false}
                endAdornment={
                  <InputAdornment position="end">.hiboutik.com</InputAdornment>
                }
              />
              <FormHelperText>
                {errors.hiboutikAccount
                  ? errors.hiboutikAccount
                  : hiboutikAccountHelper}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.hiboutikPassword}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="password">Mot de passe</InputLabel>
              <Input
                id="adornment-password"
                disabled={this.props.hbAccountCreated || false}
                type={showPassword ? 'text' : 'password'}
                value={hiboutikPassword}
                onChange={this.handleChange('hiboutikPassword')}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={this.handleClickShowPasssword}
                      onMouseDown={this.handleMouseDownPassword}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText>
                {errors.hiboutikPassword ? errors.hiboutikPassword : null}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={hiboutikCGS}
                  disabled={this.props.hbAccountCreated || false}
                  onChange={this.handleChange('hiboutikCGS')}
                  value="hiboutikCGS"
                />
              }
              label={
                <span>
                  <Typography variant="subheading">
                    <Link
                      target="_blank"
                      to="http://www.hiboutik.fr/cgs_hiboutik_fr.pdf">
                      {`J'accepte les termes et conditions de service`}
                    </Link>
                  </Typography>
                </span>
              }
            />
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <Button
              variant="raised"
              className={classes.button}
              color="primary"
              disabled={createAccountDisabled || loading}
              onClick={this.handleCreateAccountClick}>
              <Icon className={classes.leftIcon}>account_circle</Icon>
              Créer un compte
              {!this.props.hbAccountCreated &&
                loading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
            </Button>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/HiboutikAccountCreation/RightHiboutikFormComponent.js